import { useFormsStore } from '../../../../stores/onboarding'
import { usePersonalStore } from '../../../../stores/personalInfo'
import { useInitializeStore } from '../../../../stores/initialize'
import Toast from 'react-native-toast-message'
import { globalStyles } from '../../../../static/styles/global'
import { View } from 'react-native'
import HomeDetailsHeader from '../../../home/HomeDetailsHeader'
import SignatureFormView from '../../SignatureFormView'
import { useEffect, useState } from 'react'
import { Loading } from '../../../shared/navigator/Loading'
const CityMarketsAcknowledgement = ({ navigation, route }: any) => {
    const { essUserOnBoardingKey, essUserOnBoardingFormKey, description } = route.params
    const { loading, PostCityMarketForm } = useFormsStore()
    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()
    const [success, setSuccess] = useState(false)

    const intialPost = async () => {
        const data = {
            completeOnline: true,
            essUserKey: intializestore.initializeData.userkey,
            entityId: personalstore.personalData?.entityId,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            essObKey: essUserOnBoardingKey
        }
        const response = await PostCityMarketForm(data)
        if (response?.success) {
            setSuccess(true)
        }
    }

    useEffect(() => {
        intialPost()
    }, [])

    const handlesubmit = async (signatureDataURL: string) => {
        const data = {
            completeOnline: true,
            essUserKey: intializestore.initializeData.userkey,
            entityId: personalstore.personalData?.entityId,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            essObKey: essUserOnBoardingKey,
            sign: signatureDataURL
        }
        const response = await PostCityMarketForm(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }
    return (
        <>
            {success ? (
                <>
                    <View
                        style={[globalStyles.primaryBgColor, globalStyles.containerBand]}
                    >
                        <View style={[globalStyles.horizontalPadGap]}>
                            <HomeDetailsHeader
                                navLabel="Forms"
                                navScreen="OnboardingForms"
                                title={description}
                            />
                        </View>
                    </View>
                    <SignatureFormView
                        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                        essUserOnBoardingKey={essUserOnBoardingKey}
                        isSubmitting={loading}
                        onPrevious={() => navigation.navigate('OnboardingForms')}
                        onSubmit={handlesubmit}
                    />
                </>
            ) : (

                <Loading />

            )}
        </>
    )
}

export default CityMarketsAcknowledgement
